import React from 'react';
import { Navigate } from 'react-router-dom';
import SessionService from '@/services/session.service';
import { UserPermissions, hasPermission } from '@/enums/user-permissions.enum';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredPermission?: UserPermissions;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredPermission }) => {
  const isLoggedIn = SessionService.isLoggedIn();

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  // Check permission if required
  if (requiredPermission !== undefined) {
    const userPermissions = SessionService.getPermissions();
    if (!hasPermission(userPermissions, requiredPermission)) {
      return <Navigate to="/errors/forbidden" replace />;
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute;
